import { SHORTLIST_STORAGE_KEY } from './storage'

export const SHORTLIST_CHANGE_EVENT = 'hapisumu:reform-case-shortlist-changed'
const syncBindings = new Set()
let globalSyncInitialized = false

function syncConnectedBindings() {
  syncBindings.forEach((binding) => {
    if (!binding.root.isConnected) {
      syncBindings.delete(binding)
      return
    }
    binding.sync()
  })
}

function initGlobalSync() {
  if (globalSyncInitialized) return
  globalSyncInitialized = true

  window.addEventListener('storage', (event) => {
    if (event.key === SHORTLIST_STORAGE_KEY || event.key === null) syncConnectedBindings()
  })
  window.addEventListener(SHORTLIST_CHANGE_EVENT, syncConnectedBindings)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) syncConnectedBindings()
  })
}

export function bindShortlistSync(root, sync) {
  initGlobalSync()
  syncBindings.add({ root, sync })
  sync()
}
